module.exports = __webpack_public_path__ + "static/media/S1_00041.bbe4858e.jpg";